<template>
  <div class="page">
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div> -->
      <!-- <div class="hint">你在哪个城市？</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661161790.png">
      <div class="input-address province" @click="showCityPickerPop()">{{ !province ? "选择省份" : province }}</div>
      <div class="input-address city" @click="showCityPickerPop()">{{ !city ? "选择城市" : city }}</div>
      <van-popup class="citypicker" v-model="showCityPicker" round position="bottom" :close-on-click-overlay="false">
        <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="showCityPicker = false"
        @finish="confirmPickerPickerPop"
        />
      </van-popup>
      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon, Cascader, Popup } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup
  },
  data(){
    return {
      province: '',
      city: '',
      showCityPicker: false,
      cascaderValue: '',
      options: []
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(!this.province){
        Toast('请选择你的省份')
      }else if(!this.city){
        Toast('请选择你的城市')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myProvince = this.province
        cpchoose.myCity = this.city
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_jobs')
      }
    },
    showCityPickerPop(){
      this.showCityPicker = true
    },
    hideCityPickerPop(){
      this.showCityPicker = false
    },
    confirmPickerPickerPop({ selectedOptions }){
      this.showCityPicker = false
      this.province = selectedOptions[0].text
      this.city = selectedOptions[1].text
    },
    getProvincesAndCities(){
      this.$api.get('/district/get_provinces_and_cities', {}, res => {
        if(res.code == 200){
          this.options = res.provinces
        }
      })
    },
    recoverLocation(){
      this.province = this.$store.state.cpchoose.myProvince ? this.$store.state.cpchoose.myProvince : this.province
      this.city = this.$store.state.cpchoose.myCity ? this.$store.state.cpchoose.myCity : this.city
    }
  },
  mounted(){
    this.recoverLocation()
    this.getProvincesAndCities()
    this.$report.submit('/choose_me_city', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;overflow:hidden;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:160px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:146px;}
.main .pic-hint{width:270px;height:40px;margin:0 auto;margin-bottom:160px;}
.main .input-address{
  font-size:40px;color:#eb8e80;width:340px;
  background:#fff;border:1px dashed #eb8e80;height:86px;line-height:86px;margin:0px auto;
}
.main .input-address.city{margin-top:98px;}
.main .arrows{position: fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
